import { WhatsAppIcon } from "./Icons";
import { waLink } from "@/lib/site";

export const FloatingWhatsApp = () => (
  <a
    href={waLink("أهلاً خرابيش موشن، عايز أعمل إعلان")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="كلمنا على واتساب"
    data-testid="floating-whatsapp-btn"
    className="group km-pulse-ring fixed bottom-5 left-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform duration-200 hover:scale-110 sm:h-16 sm:w-16"
  >
    <WhatsAppIcon className="h-7 w-7 sm:h-8 sm:w-8" />
    <span className="font-head pointer-events-none absolute left-full ml-3 hidden whitespace-nowrap rounded-xl bg-white px-3 py-1.5 text-sm font-bold text-[#0b0114] opacity-0 transition-opacity duration-200 group-hover:opacity-100 sm:block">
      اتكلم معانا على الواتساب!
    </span>
  </a>
);
